<template>
    <section v-if="newBizParam">
                <!-- 规则1 start -->
                <div class="rule">
                    <el-checkbox @change="changeCheck(1);$emit('changeData',newBizParam)"  v-model="newBizParam.monthCustomerSameStaff.enabled"></el-checkbox>
                    <span class="txt">规则1：限制</span>
                    <div :class="!newBizParam.monthCustomerSameStaff.isSamePerson&&newBizParam.monthCustomerSameStaff.enabled&&isOpenCheck?'red-border':''">
                        <el-select @change="$emit('changeData',newBizParam)" :disabled="true" class="w130" v-model="newBizParam.monthCustomerSameStaff.isSamePerson" placeholder="请选择" clearable>
                            <el-option v-for="(item, index) in isSamePersonOption" :key="index" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <span class="txt"><i class="theme-color">同一月</i>拜访<i class="theme-color">同一家企业客户</i>的频次</span>
                    <p class="tips" v-if="!newBizParam.monthCustomerSameStaff.isSamePerson&&newBizParam.monthCustomerSameStaff.enabled&&isOpenCheck">请将规则填写完整</p>
                </div>
                <div class="rule-child" v-if="newBizParam.monthCustomerSameStaff.enabled">
                    <div class="rule" v-for="(item,index) in newBizParam.monthCustomerSameStaff.ruleItemList" :key="index">
                        <el-checkbox @change="item.sumLimitMax=null;$forceUpdate();$emit('changeData',newBizParam)" v-model="item.enabled"></el-checkbox>
                        <span class="txt"><i class="theme-color">{{ item.customerType==1?'药店':item.customerType==2?'商业公司':item.customerType==4?'医院':'其他' }}</i>不可超过<span :class="!item.sumLimitMax&&item.enabled&&isOpenCheck?'red-border txt':'txt'"><el-input class="rule-input-box" v-model="item.sumLimitMax"  @input="$forceUpdate();$emit('changeData',newBizParam)" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                            :min="1" :maxlength="7" :disabled="!item.enabled"></el-input></span>次</span>
                        <p class="tips" v-if="!item.sumLimitMax&&item.enabled&&isOpenCheck">请将规则填写完整</p>
                    </div>
                
                </div>
                <!-- 规则1 end-->

                <!-- 规则2 start-->
                <div class="rule">
                    <el-checkbox @change="changeCheck(2);$emit('changeData',newBizParam)" v-model="newBizParam.monthCustomerDifferentStaff.enabled"></el-checkbox>
                    <span class="txt">规则2：限制</span>
                    <div :class="!newBizParam.monthCustomerDifferentStaff.isSamePerson&&newBizParam.monthCustomerDifferentStaff.enabled&&isOpenCheck?'red-border':''">
                        <el-select @change="$emit('changeData',newBizParam)" :disabled="true" class="w130" v-model="newBizParam.monthCustomerDifferentStaff.isSamePerson" placeholder="请选择" clearable>
                            <el-option v-for="(item, index) in isSamePersonOption" :key="index" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <span class="txt"><i class="theme-color">同一月</i>拜访<i class="theme-color">同一家企业客户</i>的频次</span>
                    <p class="tips" v-if="!newBizParam.monthCustomerDifferentStaff.isSamePerson&&newBizParam.monthCustomerDifferentStaff.enabled&&isOpenCheck">请将规则填写完整</p>
                </div>
                <div class="rule-child" v-if="newBizParam.monthCustomerDifferentStaff.enabled">
                    <div class="rule" v-for="(item,index) in newBizParam.monthCustomerDifferentStaff.ruleItemList" :key="index">
                        <el-checkbox @change="item.sumLimitMax=null;$forceUpdate();$emit('changeData',newBizParam)" v-model="item.enabled"></el-checkbox>
                        <span class="txt"><i class="theme-color">{{ item.customerType==1?'药店':item.customerType==2?'商业公司':item.customerType==4?'医院':'其他' }}</i>不可超过<span :class="!item.sumLimitMax&&item.enabled&&isOpenCheck?'red-border txt':'txt'"><el-input class="rule-input-box" v-model="item.sumLimitMax"  @input="$forceUpdate();$emit('changeData',newBizParam)" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')" type="text"
                            :min="1" :maxlength="7" :disabled="!item.enabled"></el-input></span>次</span>
                        <p class="tips" v-if="!item.sumLimitMax&&item.enabled&&isOpenCheck">请将规则填写完整</p>
                    </div>
                </div>
                <!-- 规则2 end-->


            
    </section>
</template>
  
<script>
export default {
    props: ['bizParam1'],
    data() {
        return {
            ruleModel1:'first',
            ruleModel2:'first',
            isOpenCheck:false,
            optionSCDY1: [
                {
                    value: '3',
                    label: '医生',
                },
                {
                    value: '10',
                    label: '商业客户',
                },
                {
                    value: '11',
                    label: '居间人',
                },
                {
                    value: '15',
                    label: '药店联系人',
                },
            ],
            isSamePersonOption:[
                {
                    value: 'Y',
                    label: '同一人员',
                },
                {
                    value: 'N',
                    label: '不同人员',
                },
            ],
            newBizParam:null,

        };
    },
    watch: {
        bizParam1: {
            deep: true,
            handler(newBizParam) {
           
                if (!this.$route.query.guid&&this.$route.query.type!=3) return
                this.newBizParam = JSON.parse(JSON.stringify(newBizParam));
                console.log('-------')
                console.log(this.newBizParam)
                this.$forceUpdate();
            }
        }
    },
    created() {
       if (this.$route.query.guid||this.$route.query.type==3) return
       this.newBizParam = this.bizParam1;
       
    },
    methods: {
        changeCheck(i) {
            //规则1
            if (!this.newBizParam.monthCustomerSameStaff.enabled && i == 1) {
                this.newBizParam.monthCustomerSameStaff = {
                    "enabled": false,
                    "isSamePerson": 'Y',
                    "ruleItemList": [
                        {
                            "enabled": false,
                            "customerType": "1",
                            "sumLimitMax": null,
                            "isSamePersonExecute":null
                        }
                    ]
                }
            }
            //规则2
            if (!this.newBizParam.monthCustomerDifferentStaff.enabled && i == 2) {
                this.newBizParam.monthCustomerDifferentStaff = {
                    "enabled": false,
                    "isSamePerson": 'N',
                    "ruleItemList": [
                        {
                            "enabled": false,
                            "customerType": "1",
                            "sumLimitMax": null,
                            "isSamePersonExecute":null
                        }
                    ]
                }
            }
            this.$forceUpdate();
        },
        checkResult() {
            this.isOpenCheck = true;
            this.$forceUpdate();
            let { monthCustomerSameStaff,monthCustomerDifferentStaff } = this.newBizParam;
            try {
                let count = 0;
                monthCustomerSameStaff.ruleItemList.forEach(k => {
                    if (monthCustomerSameStaff.enabled && !k.enabled) {
                        count++;
                    }
                    if (count == 1) {
                        throw new Error('请至少勾选一个限制规则');
                    }
                    if (k.enabled && (!k.sumLimitMax )) {
                        throw new Error('');
                    }
                });
            } catch (e) {
                if (e.message) {
                    this.$message.error(e.message);
                }
                return;
            }
            try {
                let count = 0;
                monthCustomerDifferentStaff.ruleItemList.forEach(k => {
                    if (monthCustomerDifferentStaff.enabled && !k.enabled) {
                        count++;
                    }
                    if (count == 1) {
                        throw new Error('请至少勾选一个限制规则');
                    }
                    if (k.enabled && (!k.sumLimitMax )) {
                        throw new Error('');
                    }
                });
            } catch (e) {
                if (e.message) {
                    this.$message.error(e.message);
                }
                return;
            }
    
            return true;
            
        }
    }
};
</script>
  
<style scoped>
.rule {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-bottom: 10px;
}
.w260{
    width: 260px; 
}

.w130 {
    width: 140px;
}

.rule-input-box {
    width: 90px;
}
.txt{
    margin:0 10px;
}
.theme-color{
    color:#4FA1A4;
    font-style: normal;
}
.tips-color{
    color:red;
    font-style: normal;
}
.rule-child{
    padding-left: 24px;
    padding-top: 10px;
    padding-bottom: 10px;
    background: #fafafa;
    margin-bottom: 10px;
    margin-left: 72px;
}
.tips{
    color:red;
    font-size: 12px;
}
.red-border{
    border: 1px solid red;
    border-radius: 4px;
}
.red-border /deep/ .el-input__inner{
    border: 0 none;
}
span{
    display: inline-block;
}
.rule-child .rule:last-child{
    margin-bottom: 0px;
}
.line{
    height: 1px;
    background: #d9d9d9;
    margin:16px 0;
}
h5{
    font-size: 14px;
    color: #212212;
    width: 140px;
    text-align: left;
    margin:0;
    font-weight: normal;
}
</style>
  